import React from 'react';
import ApplicationSentContent from '../components/ApplicationSentContent/ApplicationSentContent';

const ApplicationSent: React.FC = () => {
  return (
    <>
      <ApplicationSentContent />
    </>
  );
};

export default ApplicationSent;
